export default __webpack_public_path__ + "static/media/arrow_forward_black-1@2x.02ffd135.png";